import React,{useEffect} from 'react';
import '../../assets/css/header-footer.css';
import '../../services/layoutService';
import { getHeader } from '../../services/layoutService';
const Header = () => {
 useEffect(() => {
          getHeader('687PDC','EN');
  }, []);
   return (
    <>
      <header id="header" className="ph-header-main">
      </header>
    </>
   );
};

export default Header;
